/*eslint react-hooks/exhaustive-deps: "off"*/
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Alert, Button, Drawer, Icon, Table, Tabs } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import MapPropsContext from "../MapPropsContext";
import { getAsisExcelList, getListByUidArray } from "../../../api";
import { getApiHost, getLastDomByClassName, makeTableSorterFn } from "../../../utils";
import Axios from "axios";
import usePortal from "react-useportal";
import AlignCenterText from "./AlignCenterText";
import AlignRightText from "./AlignRightText";

const WidgetTableBroadcast = ({ getTitle, columns, fetchUrl, latitude, longitude }) => {
  const { filteredPointsResponseList, clickedPointIconObjects } = useContext(MapPropsContext);

  const [detailObjects, setDetailObjects] = useState();
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState();
  const [errorRadio, setErrorRadio] = useState();

  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingRadio, setIsDownloadingRadio] = useState(false);

  // 컬럼 정렬 기준값을 담아둘 상탯값을 정의하고, 이를 각 컬럼의 sortOrder에 반영합니다.
  const [sortedInfo, setSortedInfo] = useState({});
  const newColumns = useMemo(() => {
    return columns.map((column) => {
      const { dataIndex } = column;
      const { columnKey, order } = sortedInfo || {};
      const sortOrder = columnKey === dataIndex && order;
      return {
        ...column,
        sortOrder,
      };
    });
  }, [columns, sortedInfo]);

  // 테이블의 변경정보를 관련 상탯값에 반영합니다.
  const onChangeTable = useCallback((pagination, filters, sorter) => {
    setSortedInfo(sorter);
  }, []);

  // 다수 Points 레이어내 무선국 정보를 하나의 Array로 통합합니다.
  const integratedLayer = filteredPointsResponseList.flat();
  const tableTitle = getTitle(integratedLayer);

  const uidArray = useMemo(() => {
    return integratedLayer.map(({ uid }) => uid);
  }, [filteredPointsResponseList]);

  useEffect(() => {
    if (!visible) {
      setDetailObjects(undefined);
      setSortedInfo(null);
    } else if (visible && fetchUrl) {
      setError(undefined);
      getListByUidArray({ relUrl: fetchUrl, uidArray })
        .then(({ data }) => {
          setDetailObjects(data.data); // data(response)에서 data객체 참조
        })
        .catch((e) => {
          setError(e);
        });
    }
  }, [visible, uidArray, fetchUrl]);

  useEffect(() => {
    // 딜레이를 주어, 보다 자연스럽게 Drawer창을 끕니다.
    setTimeout(() => {
      setVisible(false);
    }, 200);
  }, [clickedPointIconObjects]);

  const downloadXlsx = useCallback(() => {
    setIsDownloading(true);
    getListByUidArray({ relUrl: fetchUrl, uidArray, isExcelDownload: true })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setIsDownloading(false);
      });
  }, [uidArray, fetchUrl]);

  ////////// 라디오 수신 정보 테이블 관련/////////
  const [tableData, setTableData] = useState();
  const [sigCd, setSigCd] = useState();
  const [sigGb, setSigGb] = useState();

  const getRadioTableData = ({ setTableData }) => {
    setIsDownloadingRadio(true);

    const url = getApiHost() + "/gis/getbroadcastPopupList.json";
    const formData = new FormData();
    //lon: 127.475037415012
    // lat: 36.3239202445626
    formData.append("lat", latitude);
    formData.append("lon", longitude);

    Axios.post(url, formData)
      .then((response) => {
        const { data } = response;
        setTableData(data);
        setSigCd(data[0].SIGCD);
        setSigGb(data[0].SIGGB);
      })
      .catch((e) => {
        setErrorRadio(e);
      })
      .finally(() => {
        setIsDownloadingRadio(false);
      });
  };

  ////////라디오 엑셀///////////////////
  const downloadXlsxforRadio = useCallback(() => {
    setIsDownloadingRadio(true);

    let formData = new FormData();
    formData.append("excelUrl", "/gis/getbroadcastPagedPopExcel.do");
    formData.append("lat", latitude);
    formData.append("lon", longitude);
    formData.append("sigCd", sigCd);
    formData.append("sigGb", sigGb);
    formData.append("rows", 65000);
    const excelFileName = "방송수신정보.xls";
    // const url = '/gis/getbroadcastPagedPopExcel.do';

    getAsisExcelList({ formData, excelFileName })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        setIsDownloadingRadio(false);
      });
  }, [latitude, longitude, sigCd, sigGb, visible]);

  ////////////라디오 끝/////////////////

  useEffect(() => {
    if (visible) {
      setErrorRadio(undefined);
      getRadioTableData({ setTableData });
    }
  }, [latitude, longitude, visible]);

  const { Portal } = usePortal({
    bindTo: getLastDomByClassName("toolbar-show-list"),
  });

  return (
    <>
      <Portal>
        <Button type={visible ? "primary" : undefined} onClick={() => setVisible(true)}>
          목록 보기
        </Button>
      </Portal>

      <Drawer
        // title={getTitle(integratedLayer)}
        placement={"bottom"}
        height={557}
        closable={false}
        onClose={() => setVisible(false)}
        bodyStyle={{ padding: 12, overflowX: "hidden" }}
        visible={visible}
      >
        <Tabs defaultActiveKey={"dmb"} type={"card"}>
          <Tabs.TabPane tab={`방송수신정보 (${tableTitle})`} key={"dmb"}>
            {!fetchUrl && <Alert type="error" message="fetchUrl 미등록" />}
            {fetchUrl && (
              <>
                <div style={STYLE_SUBMIT}>
                  <Button onClick={downloadXlsx} style={{ marginRight: 8 }} type="primary" disabled={!fetchUrl || isDownloading}>
                    {isDownloading && <Icon type="loading" />}
                    {!isDownloading && <FontAwesomeIcon icon={faFileExcel} />}
                    <span style={{ marginLeft: 8 }}>엑셀 내보내기</span>
                  </Button>
                  <Button onClick={() => setVisible(false)}>닫기</Button>
                </div>
                <div style={STYLE_CONTENT}>
                  {error && <Alert message={"데이터 로딩에 실패했습니다. 잠시 후 다시 시도해주세요."} type={"error"} />}
                  {!error && (
                    <Table
                      dataSource={
                        detailObjects &&
                        detailObjects.map((row, index) => ({
                          index: index + 1,
                          ...row,
                        }))
                      }
                      columns={newColumns}
                      onChange={onChangeTable}
                      size={"middle"}
                      rowKey={"index"}
                      // bordered={true}
                      loading={!detailObjects && !error}
                      ellipsis={true}
                      pagination={{
                        pageSizeOptions: ["10", "50", "100"],
                        showSizeChanger: true,
                      }}
                      scroll={{ y: 350 }}
                      tableLayout={"fixed"}
                    />
                  )}
                </div>
              </>
            )}
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              tableData && tableData.length > 0 && tableData[0].TOT_NUM ? `라디오 수신정보 (${tableData[0].TOT_NUM}개)` : "라디오 수신정보"
            }
            key={"radio"}
          >
            <>
              <div style={STYLE_SUBMIT}>
                <Button onClick={downloadXlsxforRadio} style={{ marginRight: 8 }} type="primary" disabled={tableData && isDownloadingRadio}>
                  {!tableData && <Icon type="loading" />}
                  {tableData && <FontAwesomeIcon icon={faFileExcel} />}
                  <span style={{ marginLeft: 8 }}>엑셀 내보내기</span>
                </Button>
                <Button onClick={() => setVisible(false)}>닫기</Button>
              </div>
              <div style={STYLE_CONTENT}>
                {errorRadio && <Alert message={"데이터 로딩에 실패했습니다. 잠시 후 다시 시도해주세요."} type={"error"} />}
                {!errorRadio && tableData && tableData.length > 0 && (
                  <Table
                    dataSource={tableData}
                    columns={[
                      {
                        title: "순번",
                        dataIndex: "RN",
                        key: "RN",
                        width: 80,
                        align: "center",
                      },
                      {
                        title: "종류",
                        dataIndex: "SERVICE",
                        key: "SERVICE",
                        width: 120,
                        align: "center",
                        render: (text) => AlignCenterText({ text }),
                        sorter: makeTableSorterFn("SERVICE"),
                      },
                      {
                        title: "방송사",
                        dataIndex: "BROAD_NM",
                        key: "BROAD_NM",
                        width: 120,
                        align: "center",
                        render: (text) => AlignCenterText({ text }),
                        sorter: makeTableSorterFn("BROAD_NM"),
                      },
                      {
                        title: "채널",
                        dataIndex: "SERVICE_NM",
                        key: "SERVICE_NM",
                        align: "center",
                        sorter: makeTableSorterFn("SERVICE_NM"),
                      },
                      {
                        title: "주파수",
                        dataIndex: "BROD_FREQ",
                        key: "BROD_FREQ",
                        width: 120,
                        align: "center",
                        render: (text) => AlignRightText({ text }),
                        sorter: makeTableSorterFn("BROD_FREQ"),
                      },
                    ]}
                    size={"middle"}
                    rowKey={"RN"}
                    // bordered={true}
                    loading={!tableData && !errorRadio}
                    ellipsis={true}
                    pagination={{
                      pageSizeOptions: ["10", "20"],
                      showSizeChanger: true,
                    }}
                    scroll={{ y: 350 }}
                    tableLayout={"fixed"}
                  />
                )}
              </div>
            </>
          </Tabs.TabPane>
        </Tabs>
      </Drawer>
    </>
  );
};

const STYLE_CONTENT = {
  height: "400px",
  marginBottom: "30px",
};

const STYLE_SUBMIT = {
  position: "absolute",
  top: -10,
  right: 2,
  padding: "10px 12px",
};

export default WidgetTableBroadcast;
